import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  constructor() { }

  fullyLoaded() {
    // this will be used once the content of the page (including images) has been fully loaded
    (window as any).hideAppShell();
  }

  async nativeShare(options: { title?: string; text?: string; url?: string }) {
    if (navigator.share) {
      try {
        await navigator.share(options);
      } catch (e) {
        console.warn('Share cancelled or failed', e);
      }
    } else {
      console.warn('Web Share API not supported');
    }
  }

  copyLink(url: string) {
    navigator.clipboard.writeText(url);
    return Promise.resolve(true);
  }

  shareFacebook(url: string) {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
  }

  shareTwitter(url: string, text?: string) {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(text || '')}&url=${encodeURIComponent(url)}`,
      '_blank'
    );
  }

  shareEmail(subject: string, body: string) {
    window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`, '_self');
  }


}
